
import { Box, ListItem, ListItemIcon, ListItemText, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Square } from "@mui/icons-material";
import { useMemo } from "react";
import { AlarmScheduleListActionEnum } from "./AlarmScheduleListUtils";
import ActionMenu from "../../../components/action-menu/ActionMenu";
import { IAlarmScheduleLinkedAlarmSchemeModel } from "../../../services/alarm-schedule-data-service/Models";
import { ActionMenuItem } from "../../../components/action-menu/ActionMenuItem";

export type AlarmScheduleUsageListItemProps = {
    item: IAlarmScheduleLinkedAlarmSchemeModel,
    onAction: (action: AlarmScheduleListActionEnum, payload: IAlarmScheduleLinkedAlarmSchemeModel) => void,
};

export function AlarmScheduleUsageListItem({
    item,
    onAction,
}: AlarmScheduleUsageListItemProps) {

    const { t } = useTranslation();
    const theme = useTheme();

    const actionItems: ActionMenuItem[] = useMemo(() => {

        const actions: ActionMenuItem[] = [{
            label: t("actions.edit"),
            action: AlarmScheduleListActionEnum.EditAlarmScheme,
            onClick: () => {onAction(AlarmScheduleListActionEnum.EditAlarmScheme, item)}, 
            order: 0
        }];    
    
        return actions;

    }, [
        t,
        item,
        onAction
    ]);


    return (
        <ListItem disablePadding >
            <ListItemIcon sx={{fontSize: ".4rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
                <Square fontSize="inherit"/>
            </ListItemIcon>
            <ListItemText 
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: 0
                }}
                primary={
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                flex: '1 1 auto',
                                overflow: 'hidden'
                            }}>
                            {item.name}
                        </Box>

                        {
                        actionItems.length ?

                            <Box sx={{
                                display: 'flex'
                            }}>
                                <ActionMenu
                                    actionItems={actionItems}
                                />
                            </Box>
                            : null
                        }
                    </>
                } 
            
                slotProps={{
                    primary: {
                        component: 'div',
                        sx: {
                            fontSize: '.9rem',
                            display: 'flex',
                            color: theme.palette.grey[600]
                        }
                    }
                }} 
            />
        </ListItem>
    );
}
